/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Shop_Home_StoresInputs */

const vi_shop_home_stores = /** @type {(inputs: Shop_Home_StoresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cửa hàng (tối đa ${i?.max})`)
};

/**

* @param {Shop_Home_StoresInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_stores = /** @type {((inputs: Shop_Home_StoresInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_StoresInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_stores(inputs)
});